import { Circle, Path, Svg } from "@react-pdf/renderer";

type CompletionIconProps = {
  style?: React.ComponentProps<typeof Svg>["style"];
};

export const CompletionIcon = ({ style }: CompletionIconProps) => {
  return (
    <Svg width="30" height="30" viewBox="0 0 30 30" style={style}>
      <Circle cx="15" cy="15" r="15" fill="#FDFDFE" />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1008 6C11.589 6 8.73828 8.85072 8.73828 12.3626C8.73828 15.8744 11.589 18.7251 15.1008 18.7251C18.6127 18.7251 21.4634 15.8744 21.4634 12.3626C21.4634 8.85072 18.6127 6 15.1008 6ZM15.1008 6.90894C18.1105 6.90894 20.5545 9.35289 20.5545 12.3626C20.5545 15.3722 18.1105 17.8162 15.1008 17.8162C12.0912 17.8162 9.64722 15.3722 9.64722 12.3626C9.64722 9.35289 12.0912 6.90894 15.1008 6.90894Z"
        fill="#6690A3"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6432 10.0591V15.544C14.6432 15.7951 14.8466 15.9984 15.0977 15.9984C15.3482 15.9984 15.5522 15.7951 15.5522 15.544V10.0591L17.7807 12.2876C17.958 12.4649 18.246 12.4649 18.4232 12.2876C18.6005 12.1104 18.6005 11.8224 18.4232 11.6451C18.4232 11.6451 16.7502 9.97152 15.9009 9.12221C15.6879 8.90918 15.3987 8.78931 15.0976 8.78931C14.796 8.78931 14.5074 8.90917 14.2938 9.12221C13.4218 9.99479 13.6803 9.73632 11.7584 11.6582C11.5805 11.8355 11.5805 12.1235 11.7584 12.3007C11.9356 12.478 12.2236 12.478 12.4009 12.3007L14.6432 10.0591Z"
        fill="#6690A3"
      />
      <Path
        d="M22.9057 24.0042H7.09454C6.49112 24.0042 6 23.375 6 22.6024V21.2523C6 20.4794 6.49112 19.8504 7.09454 19.8504H22.9057C23.5091 19.8504 24 20.4794 24 21.2523V22.6024C24 23.375 23.5091 24.0042 22.9057 24.0042ZM7.09454 20.1228C6.60832 20.1228 6.2127 20.6295 6.2127 21.2523V22.6021C6.2127 23.2251 6.60832 23.7316 7.09454 23.7316H22.9057C23.3917 23.7316 23.7873 23.2251 23.7873 22.6021V21.2523C23.7873 20.6295 23.3921 20.1228 22.9057 20.1228H7.09454Z"
        fill="#6690A3"
      />
      <Path
        d="M7.98372 20.4285C7.44055 20.4285 7 20.8667 7 21.4066V22.4501C7 22.9909 7.44055 23.4285 7.98372 23.4285H8.52294L11 20.4288H7.98372V20.4285Z"
        fill="#6690A3"
      />
      <Path d="M11.848 20.4285L9.43359 23.4285H13.0192L15.4336 20.4285H11.848Z" fill="#6690A3" />
      <Path d="M16.4144 20.4285L14 23.4285H17.5856L20 20.4285H16.4144Z" fill="#6690A3" />
    </Svg>
  );
};
